// src/components/HeroSection.js
import React, { useState } from "react";
import {
    FaArrowRight,
    FaShoppingCart,
    FaCreditCard,
    FaMobileAlt,
    FaWhatsapp,
    FaStar,
    FaTruck,
    FaClock,
    FaBoxOpen,
    FaPlus,
    FaMinus,
    FaMoneyBillWave,
    FaCheckCircle,
    FaTag,
    FaGem,
    FaRocket
} from "react-icons/fa";
import { IoSparklesOutline, IoShirtOutline } from "react-icons/io5";
import StoreRequestPopup from './StoreRequestPopup';
import "./HeroSection.css";

const HeroSection = () => {
    const [isPopupOpen, setIsPopupOpen] = useState(false);

    const handleGetStartedClick = () => {
        setIsPopupOpen(true);
    };

    const handleDemoClick = () => {
        window.open('https://demo-site.creativepulse.pk/', '_blank', 'noopener,noreferrer');
    };

    return (
        <>
            <section className="hero-section">
                {/* Background Effects */}
                <div className="hero-bg-gradient"></div>
                <div className="blob blob-1"></div>
                <div className="blob blob-2"></div>
                <div className="grid-pattern"></div>

                <div className="hero-container">
                    {/* Left Content */}
                    <div className="hero-content animate-fade-up">
                        <div className="launch-badge">
                            <span className="pulse-dot-container">
                                <span className="pulse-dot-ring"></span>
                                <span className="pulse-dot"></span>
                            </span>
                            Launch-ready in 3 days
                        </div>

                        <h1 className="hero-title">
                            Launch Your <span className="gradient-coral">E-commerce</span> Website in{' '}
                            <span className="gradient-text-wrapper">
                                <span className="gradient-text">3 Days</span>
                                <svg viewBox="0 0 200 12" className="underline-svg" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round">
                                    <path d="M3 9 Q 50 1 100 6 T 197 5"></path>
                                </svg>
                            </span>
                        </h1>

                        <p className="hero-description">
                            Get your own branded online store in 3 days without the high cost
                            or hassle of custom development.
                        </p>

                        <div className="hero-buttons">
                            <button className="primary-btn shine-on-hover" onClick={handleDemoClick}>
                                View Demo Store
                                <FaArrowRight className="btn-icon" />
                            </button>

                            <button className="secondary-btn glass-btn" onClick={handleGetStartedClick}>
                                Get Started
                            </button>
                        </div>

                        <div className="hero-features">
                            <span className="feature-pill-hero">
                                <FaMobileAlt className="feature-icon" />
                                Mobile-first
                            </span>

                            <span className="feature-pill-hero">
                                <FaCreditCard className="feature-icon" />
                                COD + Online
                            </span>

                            <span className="feature-pill-hero">
                                <FaWhatsapp className="feature-icon" />
                                WhatsApp Support
                            </span>

                            <span className="feature-pill-hero">
                                <IoSparklesOutline className="feature-icon" />
                                Managed Setup
                            </span>
                        </div>
                    </div>

                    {/* Right Side Mockup */}
                    <div className="hero-visual">
                        {/* Desktop Mockup */}
                        <div className="desktop-card shadow-float rotate-negative">
                            <div className="desktop-inner">
                                <div className="browser-controls">
                                    <span className="browser-dot dot-red"></span>
                                    <span className="browser-dot dot-yellow"></span>
                                    <span className="browser-dot dot-green"></span>
                                    <span className="browser-url">atelier-noor.com</span>
                                </div>

                                <div className="desktop-content">
                                    <div className="desktop-banner"></div>

                                    <div className="product-grid">
                                        <div className="product-box">
                                            <FaBoxOpen className="box-icon" />
                                        </div>

                                        <div className="product-box">
                                            <FaBoxOpen className="box-icon" />
                                        </div>

                                        <div className="product-box">
                                            <FaBoxOpen className="box-icon" />
                                        </div>
                                    </div>

                                    <div className="desktop-footer"></div>
                                </div>
                            </div>
                        </div>

                        {/* Phone Mockup */}
                        <div className="phone-card shadow-float rotate-positive">
                            <div className="phone-inner">
                                <div className="phone-notch">
                                    <span className="notch-line"></span>
                                </div>

                                <div className="phone-header">
                                    <span className="phone-brand">atelier noor</span>
                                    <FaShoppingCart className="phone-cart" />
                                </div>

                                <div className="phone-product-image">
                                    <div className="product-icon-wrapper">
                                        <IoShirtOutline className="product-icon" />
                                    </div>
                                    <span className="new-tag">NEW</span>
                                </div>

                                <div className="phone-product-info">
                                    <h4 className="product-name">Linen Co-ord Set</h4>

                                    <div className="price-rating">
                                        <strong className="product-price">PKR 4,890</strong>
                                        <span className="product-rating">
                                            <FaStar className="star-icon filled" />
                                            4.8
                                        </span>
                                    </div>
                                </div>

                                <div className="phone-sizes">
                                    <span className="size-option">S</span>
                                    <span className="size-option active">M</span>
                                    <span className="size-option">L</span>
                                </div>

                                <button className="phone-add-to-cart">Add to Cart</button>
                            </div>
                        </div>

                        {/* Floating Cart */}
                        <div className="floating-card cart-card shadow-float animate-float-slow">
                            <div className="card-header">
                                <h5 className="card-title-hero">
                                    <FaShoppingCart className="card-icon" />
                                    Your Cart
                                </h5>
                                <span className="cart-count">2 items</span>
                            </div>

                            <div className="cart-item">
                                <div className="cart-item-icon">
                                    <FaBoxOpen />
                                </div>
                                <div className="cart-item-details">
                                    <p className="cart-item-name">Linen Co-ord</p>
                                    <small className="cart-item-price">PKR 4,890</small>
                                </div>
                                <div className="cart-item-qty">
                                    <button className="qty-btn"><FaMinus /></button>
                                    <span>1</span>
                                    <button className="qty-btn"><FaPlus /></button>
                                </div>
                            </div>

                            <div className="cart-item">
                                <div className="cart-item-icon coral-bg">
                                    <FaBoxOpen />
                                </div>
                                <div className="cart-item-details">
                                    <p className="cart-item-name">Suede Loafers</p>
                                    <small className="cart-item-price">PKR 7,500</small>
                                </div>
                                <div className="cart-item-qty">
                                    <button className="qty-btn"><FaMinus /></button>
                                    <span>1</span>
                                    <button className="qty-btn"><FaPlus /></button>
                                </div>
                            </div>

                            <div className="cart-total-hero">
                                <span>Total</span>
                                <strong>PKR 12,390</strong>
                            </div>
                        </div>

                        {/* Payment Card */}
                        <div className="payment-rotation">
                            <div className="floating-card payment-card shadow-float animate-float-delayed">

                                <span className="payment-label">Checkout</span>
                                <p className="payment-title">Choose payment</p>

                                <div className="payment-option active">
                                    <FaMoneyBillWave className="payment-icon" />
                                    <span>Cash on Delivery</span>
                                    <FaCheckCircle className="payment-check" />
                                </div>

                                <div className="payment-option">
                                    <FaCreditCard className="payment-icon" />
                                    <span>Online Payment</span>
                                </div>

                                <button className="place-order-btn">Place Order →</button>
                            </div>
                        </div>

                        {/* WhatsApp Card */}
                        <div className="whatsapp-rotation">
                            <div className="floating-card whatsapp-card shadow-float animate-float-tiny">
                                <div className="whatsapp-header">
                                    <div className="whatsapp-avatar">
                                        <FaWhatsapp />
                                    </div>
                                    <div>
                                        <p className="whatsapp-title">WhatsApp Support</p>
                                        <span className="whatsapp-status">Online now</span>
                                    </div>
                                </div>

                                <div className="chat-message user-message">
                                    Hi! Do you have size M in stock?
                                </div>

                                <div className="chat-message support-message">
                                    Yes! Ready to ship today ✨
                                </div>
                            </div>
                        </div>

                        {/* Ready Badge */}
                        <div className="ready-badge animate-float-slow">
                            <FaClock />
                            Ready in 3 Days
                            <span className="pulse-ring"></span>
                        </div>

                        {/* Bottom Pills */}
                        <div className="bottom-pills">
                            <span className="pill">
                                <FaMoneyBillWave />
                                COD
                            </span>

                            <span className="pill dark-pill">
                                <FaCreditCard />
                                Online
                            </span>

                            <span className="pill">
                                <FaTruck />
                                Delivery
                            </span>
                        </div>
                    </div>
                </div>
            </section>

            {/* Store Request Popup */}
            <StoreRequestPopup
                isOpen={isPopupOpen}
                onClose={() => setIsPopupOpen(false)}
            />
        </>
    );
};

export default HeroSection;